<template>
  <NotFoundView v-if="appLoadFailed" />

  <MobileView v-else-if="isMobile" />

  <component
    :is="component"
    v-else
  />
</template>

<script lang="ts">

import Component from 'vue-class-component'

import PublicViewMetaInfo from '@/views/public/PublicViewMetaInfo'
import NotFoundView from '@/views/public/NotFoundView.vue'
import MobileView from '@/views/public/MobileView.vue'
import ProjectsView from '@/views/public/ProjectsView.vue'
import MapView from '@/views/public/MapView.vue'
import VisualisationView from '@/views/public/VisualisationView.vue'
import EditMapView from '@/views/public/EditMapView.vue'

import {
  MOBILE_VIEWPORT_WIDTH,
  VIEW_PROJECTS,
  VIEW_MAP,
  EDIT_MAP_VIEW,
  VIEW_VISUAL,
} from '@/constants'

const components = {
  NotFoundView,
  MobileView,
  ProjectsView,
  MapView,
  VisualisationView,
  EditMapView,
}

@Component({ components })
export default class PublicView extends PublicViewMetaInfo {
  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get mainpanel () {
    return this.$typedStore.currentRoute.params.mainpanel
  }

  get component () {
    switch (this.mainpanel) {
      case VIEW_PROJECTS:
        return ProjectsView
      case VIEW_MAP:
        return MapView
      case VIEW_VISUAL:
        return VisualisationView
      case EDIT_MAP_VIEW:
        return EditMapView
      default:
        return ProjectsView
    }
  }

  get viewportWidth () {
    return this.$typedStore.public.size.clientWidth
  }

  get isMobile () {
    return this.viewportWidth < MOBILE_VIEWPORT_WIDTH
  }

  get appLoadFailed () {
    return this.$typedStore.primary.app.appLoadFailed
  }

  get showSetupWizard () {
    return this.$route.query.showSetupWizard === 'true'
  }

  async mounted () {
    await this.initialiseApps()
    this.$typedStore.public.size.recalculate()
    if (this.showSetupWizard) {
      this.$bvModal.show('builder-wizard-modal')
    }
  }

  async updated () {
    await this.initialiseSecondaryApp()
    this.$typedStore.public.size.recalculate()
  }

  async initialiseApps () {
    await this.$typedStore.primary.app.initialise()
    await this.initialiseSecondaryApp()
  }

  async initialiseSecondaryApp () {
    if (this.$typedStore.activeVisualisation.isSecondaryApp) {
      await this.$typedStore.secondary.app.initialise()
    }
  }
}

</script>
